const settingsSchema = [
  {
    name: 'touchpos_use_dark_theme',
    initialValue: '',
    input: {
      placeholder: 'Use dark theme',
      className: 'touchpos_use_dark_theme',
      label: 'Use dark theme',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_hide_employee_stats',
    initialValue: '',
    input: {
      placeholder: 'Hide employee stats',
      className: 'touchpos_hide_employee_stats',
      label: 'Hide employee stats',
      type: 'checkbox',
    },
  },
  {
    name: 'hideCustomerInfo',
    initialValue: '',
    input: {
      placeholder: 'Hide customer search box',
      className: 'hideCustomerInfo',
      label: 'Hide customer search box',
      type: 'checkbox',
    },
  },
  {
    name: 'hideCustomerSearch',
    initialValue: '',
    input: {
      placeholder: 'Disable customer unused coupons popup',
      className: 'hideCustomerSearch',
      label: 'Disable customer unused coupons popup',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_disable_unused_coupons_popup',
    initialValue: '',
    input: {
      placeholder: 'Force system sign-off after period of inactivity (seconds)',
      className: 'touchpos_disable_unused_coupons_popup',
      label: 'Force system sign-off after period of inactivity (seconds)',
      type: 'checkbox',
    },
  },
  {
    name: 'pos_timeout',
    initialValue: '',
    input: {
      placeholder: 'Seconds',
      className: 'pos_timeout',
      type: 'input',
    },
  },
  {
    name: 'touchpos_orders_only_from_current_location',
    initialValue: '',
    input: {
      placeholder: 'Get orders only from current location',
      className: 'touchpos_orders_only_from_current_location',
      label: 'Get orders only from current location',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_laybys_only_from_current_location',
    initialValue: '',
    input: {
      placeholder: 'Get laybys only from current location',
      className: 'touchpos_laybys_only_from_current_location',
      label: 'Get laybys only from current location',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_recent_sales_only_from_current_location',
    initialValue: '',
    input: {
      placeholder: 'Get recent sales only from current location',
      className: 'touchpos_recent_sales_only_from_current_location',
      label: 'Get recent sales only from current location',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_unfinished_sales_only_from_current_location',
    initialValue: '',
    input: {
      placeholder: 'Get unfinished sales only from current location',
      className: 'touchpos_unfinished_sales_only_from_current_location',
      label: 'Get unfinished sales only from current location',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_order_to_invoice_in_current_warehouse',
    initialValue: '',
    input: {
      placeholder: 'Confirm any order to invoice in current warehouse only ',
      className: 'touchpos_order_to_invoice_in_current_warehouse',
      label: 'Confirm any order to invoice in current warehouse only ',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_disable_selling_to_default_customer',
    initialValue: '',
    input: {
      placeholder: 'Disable selling to POS default customer',
      className: 'touchpos_disable_selling_to_default_customer',
      label: 'Disable selling to POS default customer',
      type: 'checkbox',
    },
  },
  {
    name: 'touchscreen_pos',
    initialValue: '',
    input: {
      placeholder: 'Turn on On-Screen Keyboard',
      className: 'touchscreen_pos',
      label: 'Turn on On-Screen Keyboard',
      type: 'checkbox',
    },
  },
  {
    name: 'sandbox',
    initialValue: '',
    input: {
      placeholder: 'Configure POS version to use on sandbox',
      className: '',
      options: JSON.parse(localStorage.getItem('versions-pos-sb') ?? '[]'),
      label: 'Brazil Sandbox version',
    },
  },
  {
    name: 'production',
    initialValue: '',
    input: {
      placeholder: 'Configure POS version to use on production',
      className: '',
      options: JSON.parse(localStorage.getItem('versions-epos') ?? '[]'),
      label: 'Brazil Epos version',
    },
  },
];

export default settingsSchema;
